import { Inject, Injectable } from '@angular/core'
import { API_CONFIGURATION, FullApiClientConfiguration } from '@ftr/api-shared'
import { SimpleWindowRefService } from '@ftr/foundation'

@Injectable({
  providedIn: 'root',
})
export class PortalDomainService {
  constructor(
    private window: SimpleWindowRefService,
    @Inject(API_CONFIGURATION) private readonly configurationService: FullApiClientConfiguration,
  ) {}

  isPublicPortal(): boolean {
    if (this.window.isLocal()) {
      return this.window.getHostName() === 'https://localhost:3003'
    }
    return this.window.getHostName() === this.configurationService.publicAppUrl
  }

  isCourtsPortal(): boolean {
    if (this.window.isLocal()) {
      return this.window.getHostName() === 'https://localhost:3000'
    }
    return this.window.getHostName() === this.configurationService.courtsAppUrl
  }

  isSitePortal(): boolean {
    if (this.window.isLocal()) {
      return this.window.getHostName() === 'https://localhost:3004'
    }
    return this.window.getHostName() === this.configurationService.webAppUrl
  }
}
